module.exports = __webpack_public_path__ + "static/media/Jally.14862d13.webp";